export default __webpack_public_path__ + "static/media/Nuestros_valores_3.a2a97a09.png";